module.exports = __webpack_public_path__ + "static/media/webDev.131740d0.svg";